import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const DataDeletion: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const confirmationCode = searchParams.get('id');

  return (
    <div
      className="bg-gradient-to-br from-app-page-from to-app-page-to"
      style={{ width: '100%', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
    >
      <div className="app-breadcrumb-bar">
        <div className="app-breadcrumb-row">
          <button onClick={() => navigate('/')} className="app-breadcrumb-link">Home</button>
          <span className="app-breadcrumb-sep">›</span>
          <span className="app-breadcrumb-current">Data Deletion</span>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-3 pb-4 md:p-4 md:pb-4 lg:p-6 lg:pb-6">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">

          <div className="p-4 md:p-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white">
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center text-lg shrink-0">🗑️</div>
              <div className="min-w-0 text-left">
                <h1 className="text-xl md:text-2xl font-bold leading-snug">Data Deletion Request</h1>
                <p className="text-app-header-muted text-xs md:text-sm mt-0.5">How to delete your personal data from ExamMasters</p>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8 text-left">

            {confirmationCode && (
              <div className="mb-6 rounded-lg bg-green-50 border border-green-200 p-4">
                <div className="flex items-start gap-3">
                  <span className="text-green-500 text-lg">✅</span>
                  <div>
                    <p className="text-sm font-semibold text-green-800">Deletion request received</p>
                    <p className="text-sm text-green-700 mt-0.5">
                      Your data deletion request has been logged. Confirmation code:{' '}
                      <span className="font-mono font-bold">{confirmationCode}</span>
                    </p>
                    <p className="text-sm text-green-700 mt-1">
                      Your data will be permanently deleted within <strong>30 days</strong>. If you have questions,
                      contact{' '}
                      <a href="mailto:support@exammasters.com.au" className="underline">
                        support@exammasters.com.au
                      </a>{' '}
                      quoting your confirmation code.
                    </p>
                  </div>
                </div>
              </div>
            )}

            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">What data do we hold?</h2>
              <ul className="list-disc list-inside text-sm text-gray-600 leading-relaxed space-y-1">
                <li>Account information (name, email address) via Auth0 authentication.</li>
                <li>Course enrolments, practice attempt results, and exam scores.</li>
                <li>Subscription and billing records (payment history via Stripe).</li>
                <li>Any content you have submitted (e.g. question reports).</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">How to request deletion</h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                You can request complete deletion of your personal data by any of the following methods:
              </p>
              <div className="space-y-4">
                <div className="rounded-lg border border-gray-200 p-4">
                  <p className="text-sm font-semibold text-gray-800 mb-1">Option 1 — Email request</p>
                  <p className="text-sm text-gray-600">
                    Send an email to{' '}
                    <a href="mailto:support@exammasters.com.au?subject=Data%20Deletion%20Request" className="text-indigo-600 hover:underline">
                      support@exammasters.com.au
                    </a>{' '}
                    with the subject line <strong>"Data Deletion Request"</strong> and include the email address
                    associated with your account.
                  </p>
                </div>

                <div className="rounded-lg border border-gray-200 p-4">
                  <p className="text-sm font-semibold text-gray-800 mb-1">Option 2 — Account settings</p>
                  <p className="text-sm text-gray-600">
                    Log in to ExamMasters, go to <strong>Profile → Settings</strong>, and use the
                    <strong> Delete My Account</strong> option. This will immediately deactivate your account
                    and queue your data for deletion.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-2">What happens after a request?</h2>
              <ul className="list-disc list-inside text-sm text-gray-600 leading-relaxed space-y-1">
                <li>We will acknowledge your request within <strong>5 business days</strong>.</li>
                <li>All personal data will be permanently deleted within <strong>30 days</strong>.</li>
                <li>Anonymised, aggregated data that cannot identify you may be retained for analytics.</li>
                <li>We may retain billing records for the period required by Australian tax law (typically 7 years).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">Contact</h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                For any privacy or data deletion enquiries, contact us at{' '}
                <a href="mailto:support@exammasters.com.au" className="text-indigo-600 hover:underline">
                  support@exammasters.com.au
                </a>.
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
